import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { ModelsModel } from '@/models/tables/models.model';
import { ModelsService } from '@services/data-source-tables/models-service';

@Component({
  selector: 'app-button-models',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteModelsComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private modelsModel: ModelsModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected modelsService: ModelsService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.modelsModel = <ModelsModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSeller) => {
      if (deleteSeller) {
        this.modelsService.deleteModel(this.modelsModel.id).subscribe({
          next: () => {
            this.toastr.success('Sigla Modello cancellato correttamente!');

            Registry.getInstance().get('ModelsComponent').loadModels();
          },
          error: (error) => {
            LoggerService.error('deleteModel failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione della Sigla Modello.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa Sigla Modello?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata la Sigla Modello non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
